<template>
  <vs-popup class="user-edit-popup"
            id="popup"
            title="CREATE USER"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateStaffUser)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="title" name="title" rules="required" v-slot="{ errors }">
                <small class="label">Title</small>
                <v-select :clearable="false" placeholder="" v-model="createStaffForm.title" :reduce="option => option" :options="['Mr.','Mrs.','Miss']" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="first_name" name="first_name" rules="required" v-slot="{ errors }">
                <small class="label">First Name</small>
                <vs-input v-model="createStaffForm.first_name"   name="first_name" class="w-full required" label=""
                          :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="last_name" name="last_name" rules="required" v-slot="{ errors }">
                <small class="label">Last Name</small>
                <vs-input v-model="createStaffForm.last_name"   name="last_name" class="w-full required" label=""
                          :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="email" name="email" rules="required|email" v-slot="{ errors }">
                <small class="label">Email</small>
                <vs-input  v-model="createStaffForm.email" class="w-full"  name="email" type="text" label=""
                           :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full md:mb-0">
              <ValidationProvider vid="user_group" name="user_group" rules="required" v-slot="{ errors }">
                <small class="label">User Role</small>
                <v-select name="user_group" :reduce="option => option.id" v-model="createStaffForm.role_id" label="name" :closeOnSelect="true"  :options="roles" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="country_code_mobile" name="country_code_mobile" rules="" v-slot="{ errors }">
                <small class="label">Mobile Country Code</small>
                <v-select :filter-by="countryCodeFilter" :clearable="false" label="isd_code" v-model="createStaffForm.country_code_mobile" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.isd_code}} - {{option.name}} </span>
                  </template>
                </v-select>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="contact_1" name="mobile" rules="contactNumber|min_tel|max_tel" v-slot="{ errors }">
                <small class="label">Mobile</small>
                <vs-input v-model="createStaffForm.mobile" class="w-full"  name="mobile" type="text" label=""
                          :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <!-- <div class="vx-row">
            <div class="vx-col md:w-1/2 md:mb-0">
              <small class="label">Support app access only</small>
              <vs-switch v-model="createStaffForm.support_only" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </div>
          </div>
           -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const UserRepository = RepositoryFactory.get('user')
  const RolesRepository = RepositoryFactory.get('roles');
  const CountryCodeRepository = RepositoryFactory.get('countryCode');
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      roles: [],
      selectedStaff: {},
      countryCodes:{},
      selected: [],
      updateStaffSelected: [],
      createStaffForm: {
        support_only: false
      },
      reports: []
    }
  }

export default {
  name: 'CreateStaffPopUp',
  data () {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],

  methods:{
    async openPopup () {
      try {
        Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.open = true;
        await this.loadRoles();
        await this.loadCountryCodes();
      } catch (error) {

      }
    },

    async onClickCreateStaffUser () {
      const vue = this;
      this.$vs.loading()
       try {
         await UserRepository.createUser(this.createStaffForm)
         this.showSuccessMessage('New user created successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },

    async loadRoles() {
      await this.$vs.loading({
        container: '#popup',
        scale: 0.50
      });
      try {
        this.roles = [];
        const {data} = await RolesRepository.getListNoPagination()
        this.roles =  data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#popup > .con-vs-loading')
    },
    async loadCountryCodes(){
      this.$vs.loading()
      const {data} = await CountryCodeRepository.get()
      this.countryCodes = data.data
      this.$vs.loading.close()
    },
    countryCodeFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    onClickReset() {
      this.createStaffForm = {}
      this.selected= []
    }
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
}
</script>

<style scoped>
  .video-wrapper {
    width: 100%;
    height: 100%;
  }

  .video-wrapper video {
    object-fit: cover;
    width: 100%;
    height: 100%;

  }
  .image-wrapper {
    width: 100%;
    height: 75%;
  }


</style>
